export default __webpack_public_path__ + "static/logo_black-08603dbcd7fb4649a6dd551e2ddb2ea8.png";